import { render, staticRenderFns } from "./voiceAlarm.vue?vue&type=template&id=74a9200a&scoped=true&"
import script from "./voiceAlarm.vue?vue&type=script&lang=js&"
export * from "./voiceAlarm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a9200a",
  null
  
)

export default component.exports